var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildingHeight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#222222;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line_1890"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,18c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1s1,0.4,1,1v15C11,17.6,10.6,18,10,18z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_24507"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,6c-0.3,0-0.5-0.1-0.7-0.3L10,2.4L6.7,5.7c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0l4,4 c0.4,0.4,0.4,1,0,1.4C14.5,5.9,14.3,6,14,6z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path_24508"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,20c-0.3,0-0.5-0.1-0.7-0.3l-4-4c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l3.3,3.3l3.3-3.3c0.4-0.4,1-0.4,1.4,0 s0.4,1,0,1.4l-4,4C10.5,19.9,10.3,20,10,20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingHeight);
export default __webpack_public_path__ + "static/media/building-height.5e0fa0d6415a08d98219167f2677f1c9.svg";
export { ForwardRef as ReactComponent };